<template>
  <footer>
    <!-- PC端原有布局 -->
    <div class="hidden md:block pt-[50px] pb-[85px] bg-[#EBEBEB]">
      <div class="max-w-[56%] mx-auto px-4 flex justify-between">
        <!-- 1. Logo + 公司名称 -->
        <div class="flex items-center">
          <img src="@/assets/logo.png" alt="菌丰生物" class="h-20 w-[250px]">
        </div>
        <!-- 2. 产品中心 -->
        <div class="col-span-1">
          <h3 class="text-sm font-bold mb-6 text-gray-800">产品中心</h3>
          <div class="space-y-4">
            <div><router-link to="/product/1"
                class="text-gray-500 hover:text-[#41B56F] transition-colors text-xs">菌种</router-link></div>
            <div><router-link to="/product/2"
                class="text-gray-500 hover:text-[#41B56F] transition-colors text-xs">智能仿生蘑菇仓</router-link></div>
            <!-- <div>
              <router-link to="/product/3"
                class="text-gray-500 hover:text-[#41B56F] transition-colors text-xs">智能仿生蘑菇仓系统</router-link>
            </div> -->
          </div>
        </div>
        <!-- 3. 关于菌丰 -->
        <div class="col-span-1 border-l border-gray-300 pl-8">
          <h3 class="text-sm font-bold mb-6 text-gray-800">关于菌丰</h3>
          <div class="space-y-4">
            <div><router-link to="/about/company"
                class="text-gray-500 hover:text-[#41B56F] transition-colors text-xs">公司介绍</router-link></div>
            <div><router-link to="/about/base"
                class="text-gray-500 hover:text-[#41B56F] transition-colors text-xs">基地介绍</router-link></div>
            <div><router-link to="/about/contact"
                class="text-gray-500 hover:text-[#41B56F] transition-colors text-xs">在线联系</router-link></div>
          </div>
        </div>
        <div class="w-[0.5px] h-81px bg-gray-400"></div>
        <!-- 4. 服务热线 -->
        <div class="col-span-1">
          <h3 class="text-sm font-bold mb-6 text-gray-800">服务热线</h3>
          <p class="text-gray-500 mb-3 text-xs">全国服务热线电话</p>
          <p class="text-base font-bold text-red-600">13121570328</p>
        </div>
        <!-- 5. 微信公众号 -->
        <div class="col-span-1 flex flex-col items-center md:items-start">
          <h3 class="text-sm font-bold mb-6 text-gray-800 self-start">公众号</h3>
          <img src="@/assets/home/qr.jpg" alt="微信公众号二维码" class="w-[70px] h-[70px]">
          <p class="text-gray-500 mt-3 text-xs">扫一扫，关注公众号</p>
        </div>
      </div>
      <div class="h-[1px] w-full bg-gray-400 mt-[85px]"></div>
    </div>

    <!-- 移动端 绿色【联系我们】页面，和截图样式完全匹配 -->
    <div class="md:hidden">
      <div class=" bg-[#42B570] text-white py-12 px-6 flex flex-col items-center">
        <h2 class="text-[24px] font-bold mb-6">联系我们</h2>
        <p class="text-[14px] mb-4">固定电话：010-57891187</p>
        <p class="text-[14px] mb-6">联系电话：13121570328</p>
        <p class="text-[14px] mb-6">办公地址：北京市昌平区振兴路</p>
        <!-- 二维码 -->
        <img src="@/assets/home/qr.jpg" alt="公众号二维码" class="w-[95px] h-[95px] mb-4">
        <p class="text-[14px]">扫一扫</p>
        <p class="text-[14px]">关注公众号</p>
      </div>
    </div>

  </footer>
</template>
<script>
export default {
  name: "FooterNav"
}
</script>
<style scoped>
a {
  text-decoration: none;
}
</style>
